import React from 'react';
import Chart from '@framework/ui/Organisms/Analytics/Chart';
import EmptyResultOverlay from '@/creditflowresearch/ui/common/components/EmptyResultOverlay';
import { ChartTypes } from '@framework/ui/Organisms/Analytics/Chart/constants';
import { IDataChart } from './IDataChart';
import { getChartConfig } from '@/creditflowresearch/ui/common/components/FinsightChart/config';
import ChartTooltip from '@/creditflowresearch/ui/components/bonds/Charts/ChartTooltip';
import { Periods } from '@/creditflowresearch/ui/common/constants';
import HeaderChart from './HeaderChart';
import { IHeaderConfig } from './HeaderChart/IHeaderConfig';
import { ChartsGrouping, ChartType } from '@/creditflowresearch/application/Bonds/charts/constants';
import EmptyChart from '@/creditflowresearch/ui/common/components/EmptyChart';
import { ISettingsChart } from '@/creditflowresearch/domain/vo/Chart/ISettingsChart';

import styles from './finsightChart.module.scss';

interface IFinsightChartProps<T> {
  data: T[],
  headerConfig: IHeaderConfig,
  period: Periods,
  chartType: ChartType,
  grouping: ChartsGrouping,
  dataTest: string,
  isEmptyData: boolean,
  isFetching: boolean,
  emptyChartSettings: Partial<ISettingsChart>,
  events?: {
    load?: () => void,
    redraw?: () => void,
  },
}

const FinsightChart = <T extends IDataChart>({
  data,
  headerConfig,
  period,
  chartType,
  grouping,
  dataTest,
  isEmptyData,
  isFetching,
  emptyChartSettings,
  events,
}: IFinsightChartProps<T>) => (
  <div data-test={ dataTest }>
    <div className={ styles.chartContainer }>
      {
        (isEmptyData && !isFetching)
        && (
        <EmptyResultOverlay
          content="No chart data available"
          className={ styles.emptyOverlay }
        />
        )
      }
      <HeaderChart { ...headerConfig } />
      <Chart
        type={ ChartTypes.Highstock }
        data={ data }
        getConfig={ getChartConfig }
        configOptions={ { tooltipComponent: ChartTooltip, period, chartType, grouping, isEmptyData, events } }
        zeroCaseLabel={ <EmptyChart settings={ emptyChartSettings } /> }
        isFetching={ isFetching }
        updateArgs={ [true, true, true] }
      />
    </div>
  </div>
);

export default FinsightChart;
